import React from "react";
import CurrentGradeCard from "./CurrentGradeCard";
import TargetGradeCard from "./TargetGradeCard";
import AnalysisCard from "./AnalysisCard";
import LockedInsightsCard from "./LockedInsightCard";
import SidePanelActions from "./SidePanelActions";

export default function SidePanel({
  sticky = true,
  currentDisplayText,
  currentSubText,
  onSave,
  onExport,
  onImport,
  saveDisabled,
  minGrade,
  targetGrade,
  onChangeTarget,
  onCommitTarget,
  targetHelperText,
  analysis,
  analysisError,
  moduleStats,
  proLocked = false,
  proLockText = "",
  onRequestPro,
  analysisLoading = false,
  calculateLoading = false,
}) {
  return (
    <div className={sticky ? "lg:sticky lg:top-6 lg:self-start" : ""}>
      <div className="space-y-4">
        <CurrentGradeCard
          displayText={currentDisplayText}
          subText={currentSubText}
          onSave={onSave}
          onImport={onImport}
          disabled={saveDisabled}
          importLocked={proLocked}
          onRequestPro={onRequestPro}
          calculateLoading={calculateLoading}
        />

        {proLocked ? (
          <LockedInsightsCard
            proLockText={proLockText}
            onRequestPro={onRequestPro}
            minGrade={minGrade}
            targetGrade={targetGrade}
            onChangeTarget={onChangeTarget}
            onCommitTarget={onCommitTarget}
            helperText={targetHelperText}
            analysis={analysis}
            analysisError={analysisError}
            moduleStats={moduleStats}
          />
        ) : (
          <>
            <TargetGradeCard
              minGrade={minGrade}
              targetGrade={targetGrade}
              onChangeTarget={onChangeTarget}
              onCommitTarget={onCommitTarget}
              helperText={targetHelperText}
              analysis={analysis}
              analysisError={analysisError}
              locked={false}
              lockText={proLockText}
              onRequestPro={onRequestPro}
              analysisLoading={analysisLoading}
            />

            <AnalysisCard
              moduleStats={moduleStats}
              locked={false}
              lockText={proLockText}
              onRequestPro={onRequestPro}
              analysisLoading={analysisLoading}
            />
          </>
        )}

        {/* Export + Donate actions */}
        <SidePanelActions
          exportLocked={proLocked}
          onExport={onExport}
          onRequestPro={onRequestPro}
        />
      </div>
    </div>
  );
}
